import brandLogoEn from "./brand-logo-en.svg";
import brandLogoPl from "./brand-logo-pl.svg";
import type { Locale } from "./locale";

export const brandLogoForLocale = (target: Locale): string =>
    target === "pl" ? brandLogoPl : brandLogoEn;
